<template lang="pug">
div.errors-wrapper(:class="ocbClass" v-if="$slots.default || hasErrors")
  slot
  div.some-errors(v-if="hasErrors")
    ul
      li(v-for="(message, idx) in messages")
        | {{idx}}: {{message}}
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'card-in-model-errors-list-wrapper',
})
export default class CardInModelErrorsListWrapper extends Vue {
  @Prop({ default() { return {}; } })
  messages

  get hasErrors() {
    return !(Object.keys(this.messages).length === 0 && this.messages.constructor === Object);
  }

  get ocbClass() {
    return {
      'has-errors': this.hasErrors,
      'no-errors': !this.hasErrors,
    };
  }
}
</script>

<style scoped lang="less">
.errors-wrapper {
  &.has-errors {
    display: grid;
    grid-gap: 15px;
    grid-template-rows: auto auto;
    align-items: start;
    justify-items: left;
    padding: 5px;
    border: 1px dashed red;
    background: #ffe4e4;
    border-radius: 5px;
  }
  &.no-errors {
    display: inline-block;
    padding: 0;
  }
}

.some-errors {
  color: #860d0d;
}
</style>
